module.exports = __webpack_public_path__ + "img/Frame.7d526f50.png";